import { render } from "./Swiper.vue?vue&type=template&id=ff47f82e&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=ff47f82e&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff47f82e"]])

export default __exports__